import { render, staticRenderFns } from "./LeftToRightMultiSelect.vue?vue&type=template&id=2a5c52f6&scoped=true&lang=pug&"
import script from "./LeftToRightMultiSelect.vue?vue&type=script&lang=ts&"
export * from "./LeftToRightMultiSelect.vue?vue&type=script&lang=ts&"
import style0 from "./LeftToRightMultiSelect.vue?vue&type=style&index=0&id=2a5c52f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5c52f6",
  null
  
)

export default component.exports